
import { Component, Vue } from 'vue-property-decorator'
import {
  getEmptyBucketRefundPage,
  rejectEmptyBucketRefund,
  markEmptyBucketRefunded,
} from '@/api/record'
import { getStoreId } from '@/utils/cookies'
import UserNameRemark from '@/components/UserNameRemark/index.vue'
import { scheduleElTableFixedSync } from '@/utils/elTableFixedSync'

@Component({ name: 'EmptyBucketRefund', components: { UserNameRemark } })
export default class extends Vue {
  private loading = false
  private list: any[] = []
  private total = 0
  private query: any = { pageNum: 1, pageSize: 10, userPhone: '', orderNumber: '', status: null }

  mounted() {
    this.applyRouteQuery()
    this.loadList()
    window.addEventListener('resize', this.scheduleTableLayout)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleTableLayout)
  }

  private scheduleTableLayout() {
    scheduleElTableFixedSync(this, 'mainTable')
  }

  private applyRouteQuery() {
    const q = this.$route.query || {}
    if (q.orderNumber) {
      this.query.orderNumber = String(q.orderNumber)
    }
    if (q.status === '0' || q.status === '1' || q.status === '2') {
      this.query.status = Number(q.status)
    }
  }

  private get storeId() {
    const sid = getStoreId()
    return sid ? Number(sid) : undefined
  }

  private formatMoney(v: any) {
    const n = Number(v)
    return Number.isFinite(n) ? n.toFixed(2) : '0.00'
  }

  private statusText(s: number) {
    if (s === 0) return '待处理'
    if (s === 1) return '已拒绝'
    if (s === 2) return '已退款'
    return '—'
  }

  private statusTag(s: number) {
    if (s === 0) return 'warning'
    if (s === 1) return 'info'
    if (s === 2) return 'success'
    return ''
  }

  private refundedText(row: any) {
    const online = Number(row && row.refundOnlineAmount) || 0
    if (online > 0) return `已退款（微信¥${this.formatMoney(online)}）`
    return '已退款'
  }

  private handleSearch() {
    this.query.pageNum = 1
    this.loadList()
  }

  private handleReset() {
    this.query = { pageNum: 1, pageSize: 10, userPhone: '', orderNumber: '', status: null }
    this.loadList()
  }

  private async loadList() {
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        userPhone: this.query.userPhone || undefined,
        orderNumber: this.query.orderNumber || undefined,
        storeId: this.storeId,
      }
      // null/清空 = 全部（含已拒绝、已退款），勿传 status
      if (this.query.status === 0 || this.query.status === 1 || this.query.status === 2) {
        params.status = this.query.status
      }
      const { data } = await getEmptyBucketRefundPage(params)
      if (data && data.code === 1 && data.data) {
        this.list = data.data.records || []
        this.total = data.data.total || 0
      } else {
        this.list = []
        this.total = 0
        if (data && data.msg) this.$message.error(data.msg)
      }
    } catch (e: any) {
      this.list = []
      this.total = 0
      this.$message.error((e && e.message) || '加载失败')
    } finally {
      this.loading = false
      this.scheduleTableLayout()
    }
  }

  private onReject(row: any) {
    this.$prompt('请输入拒绝原因', '拒绝申请', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /\S+/,
      inputErrorMessage: '拒绝原因不能为空',
    }).then(async ({ value }: any) => {
      try {
        const { data } = await rejectEmptyBucketRefund(row.id, this.storeId, {
          rejectReason: value,
        })
        if (data && data.code === 1) {
          this.$message.success('已拒绝')
          this.loadList()
        } else {
          this.$message.error((data && data.msg) || '操作失败')
        }
      } catch (e: any) {
        this.$message.error((e && e.message) || '操作失败')
      }
    }).catch(() => {})
  }

  private onMarkRefunded(row: any) {
    this.$confirm(
      `将向用户微信原路退回押金 ¥${this.formatMoney(row.applyAmount)}（部分退款）。确认继续？`,
      '确认退押金',
      { type: 'warning' }
    ).then(async () => {
      try {
        const { data } = await markEmptyBucketRefunded(row.id, this.storeId, {})
        if (data && data.code === 1) {
          this.$message.success('押金已退回')
          this.loadList()
        } else {
          this.$message.error((data && data.msg) || '操作失败')
        }
      } catch (e: any) {
        this.$message.error((e && e.message) || '操作失败')
      }
    }).catch(() => {})
  }
}
